import React from "react";

import TravellerStepOne from "img/how-to-img/world-tour.png";
import TravellerStepTwo from "img/how-to-img/mailbox.png";
import TravellerStepThree from "img/how-to-img/bill-receipt.png";
import TravellerStepFour from "img/how-to-img/product-delivery-tracking.png";
import TravellerStepFive from "img/how-to-img/delivery-truck.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to share a QR code</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Open the Tripple Air App
          </h1>
          <p className="small-para">
            Launch the Tripple Air mobile app on your device. Make sure you're
            logged in with your registered account to access your delivery
            dashboard.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Go to 'My Deliveries' > Assigned Deliveries
          </h1>
          <p className="small-para">
            Tap on "My Deliveries" from the main menu. Then navigate to the
            "Assigned Deliveries" tab to view deliveries that are scheduled and
            awaiting pickup.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Tap 'Pick Up' on the Relevant Order
          </h1>
          <p className="small-para">
            Find the delivery that's about to be picked up. Tap the "Pick Up"
            button — you'll see a screen with a QR code icon and a token option.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Show QR Code to Driver
          </h1>
          <p className="small-para">
            When the delivery personnel arrives, tap the QR code icon to display
            the pickup QR code on your screen. The driver will scan it to
            securely verify and collect the package.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Send Token for Contactless Pickup (Optional)
          </h1>
          <p className="small-para">
            If you're unavailable or prefer a contactless exchange, tap "Copy
            Token" instead. You can paste and send this code directly to the
            driver via the in-app Driver Chat — allowing them to complete the
            pickup securely without physical contact.
          </p>
        </div>
      </div>
    </div>
  );
}
